// JavaScript module using @emotion/react to compile SCSS styles
import { css } from '@emotion/react';
import { ButtonOutlineVariant, ButtonSize, ButtonVariant } from './mixins/_buttons.mixin';
import { Transition } from './mixins/_transition.mixin';
import { Hover } from './mixins/_hover.mixin';
import { BoxShadow } from './mixins/_box-shadow.mixin';

export default $ => {
  const rules = [];
  rules.push(css`
    .btn {
      display: inline-block;
      font-family: ${$.btnFontFamily};
      font-weight: ${$.btnFontWeight};
      color: ${$.bodyColor};
      text-align: center;
      text-decoration: ${$.linkDecoration === 'none' ? 'null' : 'none'};
      white-space: ${$.btnWhiteSpace};
      vertical-align: middle;
      user-select: none;
      background-color: transparent;
      border: ${$.btnBorderWidth} solid transparent;
      ${new ButtonSize($.btnPaddingY, $.btnPaddingX, $.btnFontSize, $.btnLineHeight, $.btnBorderRadius).include($)};
      ${new Transition($.btnTransition).include($)};

      ${new Hover().include(
        $,
        css`
          color: ${$.bodyColor};
          text-decoration: none;
        `
      )}

      &:focus,
      &.focus {
        outline: 0;
        ${new BoxShadow($.btnFocusBoxShadow).include($)};
      }

      &.disabled,
      &:disabled {
        opacity: ${$.btnDisabledOpacity};
        ${new BoxShadow('none').include($)};
      }

      &:not(:disabled):not(.disabled) {
        cursor: ${$.enablePointerCursorForButtons ? 'pointer' : 'null'};

        &:active,
        &.active {
          ${new BoxShadow($.btnActiveBoxShadow).include($)};

          &:focus {
            ${new BoxShadow($.btnFocusBoxShadow, $.btnActiveBoxShadow).include($)};
          }
        }
      }
    }
  `);

  rules.push(css`
    a.btn.disabled,
    fieldset:disabled a.btn {
      pointer-events: none;
    }
  `);

  Object.entries($.themeColors).forEach(([color, value]) => {
    rules.push(css`
      .btn-${color} {
        ${new ButtonVariant(value, value).include($)};
      }

      .btn-outline-${color} {
        ${new ButtonOutlineVariant(value).include($)};
      }
    `);
  });

  rules.push(css`
    .btn-light {
      ${new ButtonVariant('#fff', '#fff').include($)};
    }
  `);

  rules.push(css`
    .btn-link {
      font-weight: ${$.fontWeightNormal};
      color: ${$.linkColor};
      text-decoration: ${$.linkDecoration};

      ${new Hover().include(
        $,
        `
        color: ${$.linkHoverColor};
        text-decoration: ${$.linkHoverDecoration};
      `
      )}

      &:focus,
      &.focus {
        text-decoration: ${$.linkHoverDecoration};
      }

      &:disabled,
      &.disabled {
        color: ${$.btnLinkDisabledColor};
        pointer-events: none;
      }
    }
  `);

  rules.push(css`
    .btn-lg {
      ${btnSizes.btnLg($)};
    }
  `);

  rules.push(css`
    .btn-sm {
      ${btnSizes.btnSm($)};
    }
  `);

  rules.push(css`
    .btn-block {
      display: block;
      width: 100%;

      + .btn-block {
        margin-top: ${$.btnBlockSpacingY};
      }
    }
  `);

  rules.push(css`
    input[type='submit'],
    input[type='reset'],
    input[type='button'] {
      &.btn-block {
        width: 100%;
      }
    }
  `);

  return css(rules);
};

export const btnSizes = {};

btnSizes.btnLg = $ => new ButtonSize($.btnPaddingYLg, $.btnPaddingXLg, $.btnFontSizeLg, $.btnLineHeightLg, $.btnBorderRadiusLg).include($);

btnSizes.btnSm = $ => new ButtonSize($.btnPaddingYSm, $.btnPaddingXSm, $.btnFontSizeSm, $.btnLineHeightSm, $.btnBorderRadiusSm).include($);
